import { Input, Text } from "@ui-kitten/components";
import Dialog from "components/Dialog";
import { AccountMemberDetails, EventAvailabilityDetails } from "features/types";
import { useAccount } from "hooks/useAccount";
import { updateAccountMemberRequest } from "queries/account.queries";
import React, { useState } from "react";
import toast from "utils/toast";

interface PlayerIdDialogProps {
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  member: AccountMemberDetails;
  event: EventAvailabilityDetails;
  onSuccess: () => void;
}

const PlayerIdDialog: React.FC<PlayerIdDialogProps> = ({
  visible,
  setVisible,
  member,
  event,
  onSuccess,
}) => {
  const [playerId, setPlayerId] = useState("");
  const [loading, setLoading] = useState(false);
  const { fetchAccount } = useAccount();
  const handleSubmit = async () => {
    if (!playerId.trim()) {
      toast.error("Please enter your player ID.");
      return;
    }
    setLoading(true);
    try {
      await updateAccountMemberRequest({
        accountId: member.accountId,
        memberId: member.id,
        extUsername: member.extUsername,
        eventId: event.eventId,
        playerId: playerId.trim(),
      });
      await fetchAccount();
      setVisible(false);
      setPlayerId("");
      onSuccess();
    } catch (error: any) {
      toast.error(error?.data?.message || "Failed to update player ID.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      visible={visible}
      setVisible={setVisible}
      cancelText="Cancel"
      onCancel={() => {
        setVisible(false);
        setPlayerId("");
      }}
      okText="Save"
      onOk={handleSubmit}
      loading={loading}
    >
      <Text category="h6" style={{ marginBottom: 16 }}>
        Player ID Required
      </Text>
      <Text category="s1" style={{ marginBottom: 12 }}>
        Please enter your player ID to make a reservation.
      </Text>
      <Input
        placeholder="Player ID"
        value={playerId}
        onChangeText={setPlayerId}
      />
    </Dialog>
  );
};

export default PlayerIdDialog;
